module.exports = __webpack_public_path__ + "static/media/bmp-simple-icon.4a3127c7.svg";